import { ActionContext } from 'vuex';
import { InventoryApi } from '@phrospr/api-backend';
import { IInventoryState } from '@/store/inventory/inventory.state';
import { IInventoryExtendedEntity } from '@phrospr/lib-models';

export const inventoryActions = {
    async startInventoryUpsert(context: ActionContext<IInventoryState, IInventoryState>, inventoryId?: number) {
        if (context.state.isCachedUpsertInventory === true) {
            context.commit('removeCacheInventory');
            if (context.state.upsertInventory !== undefined) return;
        }

        context.commit('resetInventory');
        if (inventoryId === undefined) return context.commit('createNewInventory');
        const inventory: IInventoryExtendedEntity = (
            await InventoryApi.getInventoryListPost({
                inventory_filter: { filter: { inventory_id: inventoryId }, show: { product: true, location: true } },
            })
        ).data.records[0];
        context.commit('updateInventory', inventory);
        context.commit('setSelectedProduct', inventory.product);
        context.commit('setSelectedLocation', inventory.location);
    },
};
